export default {
  "menu.login": "ログイン",
  "menu.dashboard": "ダッシュボード",
  "menu.aiRecommendation": "AI 提案履歴",
  "menu.analytics": "スマート分析",
  "menu.stock": "在庫確認",
  "menu.transaction": "入出庫",
  "menu.inventoryCheck": "棚卸",
  "menu.product": "商品管理",
  "menu.contact": "取引先",
  "menu.settings": "設定",
  "menu.pricing": "料金プラン",
  "menu.account.logout": "ログアウト",

  // hideInMenu（侧栏不显示，但需要面包屑/标题文案）
  "menu.aiLineSetup": "LINE 連携",
  "menu.aiMonthlyReport": "月次レポート",
};
